function getSessionManagerHostUrl() {
  return "/sessionmanager";
}
function getDeviceManagerHostUrl() {
  return "/devicemanager";
}
function getEventManagerHostUrl() {
  return "/eventmanager";
}
function getSignalManagerUrl() {
  return "/signalstrength";
}
function getLocationManagerUrl() {
  return "/location";
}
function getAccountManagerHostUrl() {
  return "/account";
}
function getInsightsManagerHostUrl() {
  return "/insights";
}
function getShipmentManagerHostUrl() {
  return "/shipmentmanager";
}

const config = {
  url: "/api/v1/amt",
};

export const mapboxToken =
  "pk.eyJ1Ijoia2lyYW5tYWR1IiwiYSI6ImNseGoxaXZudTFybGEyam9oZWFjenpjcjAifQ.u0ljB-2qW6Skiwg3n3PB8A";

//Thingspace image upload/fetch urls
const thingSpaceImageBaseUrl = "https://core-devint.thingspace.verizon.com/api/dm/v1/media/";
export const fetchImageUrl = `${thingSpaceImageBaseUrl}`;
export const uploadImageUrl = `${thingSpaceImageBaseUrl}actions/upload`;
export const deleteImageUrl = `${thingSpaceImageBaseUrl}`;

//Mapbox details
//Session manager apis
export const mapboxStyle = 'mapbox://styles/kiranmadu/cm8z3ig91009v01s4hx5y0nte';
export const mapboxOwner="kiranmadu";
export const terrainId="cm8z3ig91009v01s4hx5y0nte";
export const satelliteId="cm8z3jmad003l01s0dbaubf0t";

export function tsV1LogoutEndPoint() {
  return getSessionManagerHostUrl() + "/api/v1/amt/oauth2/logout";
}

export function tsV1LoginEndPoint() {
  return getSessionManagerHostUrl() + `${config.url}/login`;
}

export function fetchForgotPasswordEndPoint() {
  return getSessionManagerHostUrl() + `${config.url}/session/users/reset`;
}

//Device manager apis

export function fetchDeviceDetailsEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/details`;
}
export function fetchV1DeviceEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/action/query`;
}
export function fetchV1HistoryEndPoint(field) {
  return getDeviceManagerHostUrl() + `${config.url}/device/history/` + field;
}
export function fetchv1DeviceDetailsEndPoint() {
  return (
    getDeviceManagerHostUrl() + `${config.url}/devices/action/query/detail`
  );
}
export function fectchOrgLocEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/alldevices`;
}
export function fetchv1DeviceDetailsSensorPageEndPoint() {
  return (
    getDeviceManagerHostUrl() + `${config.url}/devices/action/query/detail/page`
  );
}

export function fetchAdminDeviceModels() {
  return (
    getDeviceManagerHostUrl() + `${config.url}/admin/deviceModels/actions/query`
  );
}

export function postSensorManualOnboard() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/sensors/onboard`;
}
export function fetchHealthScoreSummaryEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/healthscore/summary`;
}
export function fetchNetworkHealthScoreEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/healthscore/network`;
}

export function setDeviceNameEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/action/update`;
}
export function setDeviceBulkEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/bulkupdate`;
}
export function activateSensorEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/sensors/activate`;
}
export function fetchSensorsListEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/sensors`;
}
export function fetchLocationListEndPoint() {
  return getSignalManagerUrl() + `${config.url}/signalstrength/reversegeocode`;
}
export function fetchAlarmsListEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/smartAlerts/fetch`;
}

//Event manager apis
export function fetchSensorsCoordinatesEndPoint() {
  return getLocationManagerUrl() + `${config.url}/location/sensorscoordinates`;
}
export function createRuleEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/rules/create`;
}
export function fetchRulesEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/rules/fetch`;
}
export function fetchUserEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/users/fetch`;
}
export function fetchDeviceProfileEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/getdeviceprofiles`;
}
export function createUserEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/users`;
}
export function updateUserEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/users/update`;
}
export function deleteUserEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/users/delete`;
}
export function setupUserEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/users/setuppassword`;
}
export function fetchRolesEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/roles/fetch`;
}
export function validateRolesName() {
  return getAccountManagerHostUrl() + `${config.url}/roles/validate`;
}
export function createRolesEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/roles/create`;
}
export function updateRoleEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/roles/permissions`;
}
export function deleteRoleEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/roles/delete`;
}
export function fetchOrganizationEndPoint() {
  return getLocationManagerUrl() + `${config.url}/tags/getorganization`;
}
export function fetchMyprofileEndPoint() {
  return getAccountManagerHostUrl() + `${config.url}/users/me`;
}
export function createOrganizationEndPoint() {
  return getLocationManagerUrl() + `${config.url}/tags/createorganization`;
}
export function updateOrganizationEndPoint() {
  return getLocationManagerUrl() + `${config.url}/tags/updateorganization`;
}
export function deleteOrganizationEndPoint() {
  return getLocationManagerUrl() + `${config.url}/tags/deleteorganization`;
}
export function fetchLocationEndPoint() {
  return getLocationManagerUrl() + `${config.url}/tags/getlocation`;
}
export function createLocationEndPoint() {
  return getLocationManagerUrl() + `${config.url}/tags/createlocation`;
}
export function updateLocationEndPoint() {
  return getLocationManagerUrl() + `${config.url}/tags/updatelocation`;
}

export function uploadImageEndPoint() {
  return getLocationManagerUrl() + `${config.url}/media/uploadmedia`;
}
export function fetchImageEndPoint() {
  return getLocationManagerUrl() + `${config.url}/media/downloadmedia`;
}
export function deleteImageEndPoint() {
  return getLocationManagerUrl() + `${config.url}/media/deletemedia`;
}

export function deleteLocationEndPoint() {
  return getLocationManagerUrl() + `${config.url}/tags/deletelocation`;
}
export function fetchLatLongEndPoint() {
  return getLocationManagerUrl() + `${config.url}/locationmanager/fetchlatlang`;
}
export function fetchSmartAlertsEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/smartAlerts/fetch`;
}

export function updateSmartAlertEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/smartAlerts/update`;
}

export function bulkUpdateSmartAlertEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/smartAlerts/bulkupdate`;
}
export function getAlarmsBasedOnLocAndOrg() {
  return getInsightsManagerHostUrl() + `${config.url}/alarmsbytagid`;
}
export function deleteRuleEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/rules/delete`;
}
export function editRuleEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/rules/update`;
}

export function fetchNotificationGroupsEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/notification/groups/query`;
}
export function createNotificationGroupsEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/notification/groups/create`;
}
export function updateNotificationGroupsEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/notification/groups/update`;
}
export function deleteNotificationGroupsEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/notification/groups/delete`;
}

export function addUsersToNotificationGroupsEndPoint() {
  return (
    getEventManagerHostUrl() + `${config.url}/notification/groups/addUsers`
  );
}

export function fetchNotificationUsersEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/notification/users/query`;
}
export function createNotificationUsersEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/notification/users/create`;
}
export function updateNotificationUsersEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/notification/users/update`;
}
export function deleteNotificationUsersEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/notification/users/delete`;
}
export function updateDeviceEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices`;
}
export function fetchassetmapEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/eventmanager/search`;
}
export function fetchLocationAlertsEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/locationalerts`;
}
export function fetchassetCountEndPoint() {
  return getInsightsManagerHostUrl() + `${config.url}/assetcount`;
}
export function fetchallassetCountEndPoint() {
  return getInsightsManagerHostUrl() + `${config.url}/assetinsights`;
}
export function fetchLostCountEndPoint() {
  return getInsightsManagerHostUrl() + `${config.url}/lostcount`;
}
export function fetchProdCountEndPoint() {
  return getInsightsManagerHostUrl() + `${config.url}/prod-unprod-idle`;
}
export function fetchLocationHistorymapEndPoint() {
  return getInsightsManagerHostUrl() + `${config.url}/locationtelemetry`;
}

export function fetchDeviceActionQuerySensor() {
  return (
    getDeviceManagerHostUrl() + `${config.url}/devices/action/query/sensor`
  );
}

export function searchEventAction() {
  return getEventManagerHostUrl() + `${config.url}/event/search`;
}
export function fetchDeviceValEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/value`;
}
export function fetchInsightReporting() {
  return getInsightsManagerHostUrl() + `${config.url}/reportinggateways`;
}

export function fetchInsights() {
  return getInsightsManagerHostUrl() + `${config.url}/insightreports`;
}

export function fetchDeviceEventDashboard() {
  return getInsightsManagerHostUrl() + `${config.url}/deviceeventdashboard`;
}

export function fetchDeviceEventExplorer() {
  return getInsightsManagerHostUrl() + `${config.url}/deviceeventexplorer`;
}
export function createDeviceEndpoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/bleregister`;
}
export function fetchShipment() {
  return getShipmentManagerHostUrl() + `${config.url}/getshipments`;
}

export function createShipment() {
  return getShipmentManagerHostUrl() + `${config.url}/createshipment`;
}
export function fetchDeviceShipment() {
  return getDeviceManagerHostUrl() + `${config.url}`;
}

export function deleteShipment() {
  return getShipmentManagerHostUrl() + `${config.url}/deleteshipment`;
}
export function fetchShipAlertGroup() {
  return getEventManagerHostUrl() + `${config.url}/alert/groups/query`;
}
export function updateShipment() {
  return getShipmentManagerHostUrl() + `${config.url}/updateshipment`;
}

export function cloneShipment() {
  return getShipmentManagerHostUrl() + `${config.url}/cloneshipment`;
}

export function bulkUpdateShipment() {
  return getShipmentManagerHostUrl() + `${config.url}/bulkupdateshipments`;
}

export function bulkDeleteShipment() {
  return getShipmentManagerHostUrl() + `${config.url}/bulkdeleteshipments`;
}

//alert group apis
export function fetchAlertsGroupEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/alert/groups/query`;
}

export function validateAlertsGroupName() {
  return getEventManagerHostUrl() + `${config.url}/alert/groups/validate`;
}

export function createAlertsGroupEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/alert/groups/create`;
}

export function editAlertsGroupEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/alert/groups/update`;
}

export function deleteAlertsGroupEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/alert/groups/delete`;
}

export function deleteDeviceProfileEndPoint() {
  return (
    getDeviceManagerHostUrl() + `${config.url}/devices/deletedeviceprofile`
  );
}

export function createDeviceProfileEndPoint() {
  return (
    getDeviceManagerHostUrl() + `${config.url}/devices/createdeviceprofile`
  );
}

export function fetchDeviceTypesEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/getdevicetypes`;
}

export function fetchAlertGroupEndPoint() {
  return getEventManagerHostUrl() + `${config.url}/alert/groups/query`;
}

export function updateDeviceProfileEndPoint() {
  return (
    getDeviceManagerHostUrl() + `${config.url}/devices/updatedeviceprofile`
  );
}
export function shipmentValidationEndPoint() {
  return getDeviceManagerHostUrl() + `${config.url}/devices/validatedeviceprofile`;
}

export function markAsCompletedShipmentEndPoint() {
  return (
    getInsightsManagerHostUrl()+`${config.url}/shipmentlifecycle`
  );
}

export function bulkMarkAsCompletedShipmentEndPoint() {
  return (
    getInsightsManagerHostUrl()+`${config.url}/bulkshipmentlifecycle`
  );
}

export function fetchAssetEndpoint() {
  return getShipmentManagerHostUrl() + `${config.url}/assets/getassets`;
}

export function createAssetEndpoint() {
  return getShipmentManagerHostUrl() + `${config.url}/assets/createasset`;
}

export function updateAssetEndpoint() {
  return getShipmentManagerHostUrl() + `${config.url}/assets/updateasset`;
}

export function deleteAssetEndpoint() {
  return getShipmentManagerHostUrl() + `${config.url}/assets/deleteasset`;
}

